<template>
	<a @click="cancelJob"
	   class="ps-btn ps-btn--sm ps-btn--white ps-btn--shadow" href="#">{{word.cancel}}</a>
</template>

<script>
	import Swal from "sweetalert2";

	export default {
		props: [
			'url',
			'w',
			't'
		],
		data() {
			return {
				URL: this.url,
				word: null,
				text: null
			}
		},
		created() {
			this.word = JSON.parse(this.w);
			this.text = JSON.parse(this.t);
		},
		methods: {
			submit: function (cancelReason) {
				let url = this.URL;
				console.log(cancelReason);
				let fields = {
					cancel_reason: cancelReason
				};
				axios({
					method: "post",
					url: url + "?_method=post",
					data: fields
				})
					.then(function (response) {
						// delete
						Swal.fire({
							type: "success",
							text: `Canceled`,
						});
						location.reload();
					})
					.catch(function (err) {
						let errors = err.response.data.errors;
						//console.log(errors);
					});
			},
			cancelJob: function () {
				let self = this;
				Swal.fire({
					type: "question",
					text: `Do you really want to cancel this job ?`,
					confirmButtonText: "YES",
					cancelButtonText: "NO",
					showCancelButton: true,
					showCloseButton: true
				}).then(result => {
					if (result.value) {
						Swal.fire({
							type: 'info',
							text: 'Type your cancel reason (optional)',
							input: 'textarea',
							inputAttributes: {
								autocapitalize: 'off'
							},
							showCancelButton: true,
							showLoaderOnConfirm: true,
							preConfirm: (cancelReason) => {
								self.submit(cancelReason);
							},
							allowOutsideClick: () => !Swal.isLoading()
						})
					}
				});
			}
		}
	}
</script>
